import { Component } from '@angular/core';

@Component({
    selector: 'app-client-task-history-item-body',
    template: '<div><ng-content /></div>'
})
export class ClientTaskHistoryItemBodyComponent {}
